module.exports = __webpack_public_path__ + "static/images/styles/images/vehicles/R146_STG_Tday.f37ca6c3.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/vehicles/R146_STG_Tday.png
// module id = 3850
// module chunks = 11